import _ from "lodash";

export const parseCountryData = (countries) => {
  let teamList = [];
  countries.map((rowData, index) => {
    let country = rowData.country;
    teamList[index] = { value: country, label: country, flag: rowData.flag };
  });
  return teamList;
};
// api-football names FIFA tournaments without the "FIFA" prefix (e.g. "World Cup"). Override by id.
const LEAGUE_NAME_OVERRIDES = {
  1: "FIFA World Cup",
  8: "FIFA Women's World Cup",
  29: "FIFA World Cup - Qualification Africa",
  30: "FIFA World Cup - Qualification Asia",
  31: "FIFA World Cup - Qualification CONCACAF",
  32: "FIFA World Cup - Qualification Europe",
  33: "FIFA World Cup - Qualification Oceania",
  34: "FIFA World Cup - Qualification South America",
  37: "FIFA World Cup - Qualification Intercontinental Play-offs",
  490: "FIFA U-20 World Cup",
  587: "FIFA U-17 World Cup",
  880: "FIFA Women's World Cup - Qualification Europe",
  920: "FIFA U-20 Women's World Cup",
  927: "FIFA Women's World Cup - Qualification CONCACAF",
  950: "FIFA U-17 Women's World Cup",
};

// FIFA World Cup is pinned to the top of the dropdown and used as the default selection.
const DEFAULT_LEAGUE_ID = 1;

// Leagues dropdown uses full API response (no whitelist); API returns league+country with exact names.
export const parseLeagueData = (leagues) => {
  const mapLeague = (x) => ({
    id: x.league.id,
    value: `${LEAGUE_NAME_OVERRIDES[x.league.id] || x.league.name} - ${(x.country && x.country.name) || ""}`,
    img: x.league.logo ? x.league.logo : (x.country && x.country.flag),
  });
  const mapped = (Array.isArray(leagues) ? leagues : []).map(mapLeague);
  const pinnedIdx = mapped.findIndex((l) => l.id === DEFAULT_LEAGUE_ID);
  const allLeagues = pinnedIdx >= 0
    ? [mapped[pinnedIdx], ...mapped.slice(0, pinnedIdx), ...mapped.slice(pinnedIdx + 1)]
    : mapped;
  const defaultSelectedLeague = allLeagues[0] || null;
  return { allLeagues, defaultSelectedLeague };
};

export const parseUserDetails = (userData) => {
  return Object.assign({}, userData, {
    name: userData.name,
    team: {
      label: userData.team,
      value: userData.team,
      flag: userData.teamFlag,
    },
    language: {
      label: userData.language,
      value: userData.language,
    },
  });
};

export const addOrReplace = (arr, key, newData, otherData) => {
  const { predicated_id, isAwayTeamPredicted, isHomeTeamPredicted } = otherData;

  if (isHomeTeamPredicted && predicated_id === newData.predicated_team_one_id) {
    if (newData.predicated_team_two_id === null) {
      _.remove(arr, key);
    } else {
      let index = _.findIndex(arr, key);
      if (index >= 0) {
        arr[index].predicated_team_one_id = null;
      }
    }
  } else if (
    isAwayTeamPredicted &&
    predicated_id === newData.predicated_team_two_id
  ) {
    if (newData.predicated_team_one_id === null) {
      _.remove(arr, key);
    } else {
      let index = _.findIndex(arr, key);
      if (index >= 0) {
        arr[index].predicated_team_two_id = null;
      }
    }
  } else {
    let index = _.findIndex(arr, key);
    if (index >= 0) {
      arr.splice(index, 1, newData);
    } else {
      arr.push(newData);
    }
  }
  return arr;
};

export const teamShortHandName = (teamName) => {
  let newName;
  newName = teamName && teamName.substring(0, 3).toUpperCase();
  return newName;
};
export const playerShortHandName = (playerName) => {
  let playerShortName = playerName.split(" ");

  let shortPlayerName =
    playerShortName.length >= 2
      ? `${playerShortName[0]} ${playerShortName[1]}`
      : playerName;
  return shortPlayerName;
};
